import GoogleMapReact from 'google-map-react';
import { useEffect, useMemo, useState } from "react";
import { Link } from 'react-router-dom';
import { addDevice, editDevice } from "src/api/devices";
import { useGetDeviceType } from "src/api/userInfo";
import DeviceSetupFormContainer from "src/components/device_management/serverDetails/steps/deviceSetupFormContainer";
import { InputWithInnerLabel } from "src/components/ui/inputFields/input-with-label";
import { useDeviceManagement } from "src/context/stores";
import { GOOGlE_API_KEY } from "src/shared/config";
import { useSWRConfig } from 'swr';
import { shallow } from "zustand/shallow";
import { useTranslation } from 'react-i18next'

export const SetupDeviceInfo = ({step,setStep,brandList,isLoadingBrandList,type}) => {
    const selectionList = useDeviceManagement((state) => state.selectionList,shallow)
    const [updateDeviceSetup, deviceSetup] = useDeviceManagement((state) => [state.updateDeviceSetup, state.deviceSetup],shallow)
    const [formStatus, setFormStatus] = useState({isError: false, message: ''})
    const [modelSelectionList, setModelSelectionList] = useState([])
    const [brandId] = useState(deviceSetup?.brand)
    const { t } = useTranslation("settings");
    
    const handleBrandChange = (brandId) => {
        const brandModels = brandList?.filter((brand)=>brand.value == brandId)?.[0]?.model?.map((model)=>({value: model.id, label: model.name}))
        setModelSelectionList(brandModels)
    }

    useEffect(() => {
        if (deviceSetup?.brand) {
            handleBrandChange(deviceSetup?.brand)
        }
    }, [step]);
    
    
    const handleDeviceInfo = async (e) => {
        e.preventDefault();
        // get data from form
        const formData = new FormData(e.target);

        const brand = formData.get('device_brand');
        const model = formData.get('device_model');
        const device_name = formData.get('device_name');
        const description = formData.get('device_description');

        if (device_name.length < 1) {
            setFormStatus({isError: true, message: `${t('device_management.device_setup.required_name')}`})
        } else if (device_name.length <= 3) {
            setFormStatus({isError: true, message: `${t('device_management.device_setup.required_name_short')}`})
        } else if (!brand && !model) {
            setFormStatus({isError: true, message: `${t('device_management.device_setup.required_brand_model')}`})
        } else if (!model) {
            setFormStatus({isError: true, message: `${t('device_management.device_setup.required_model')}`})
        } else if (!brand) {
            setFormStatus({isError: true, message: `${t('device_management.device_setup.required_brand')}`})
        } else {
            updateDeviceSetup({
                ...deviceSetup, // Spread the previous state
                name: device_name,
                model: Number(model),
                brand: brand,
                description: description
              });
            
            setStep(n => n+1)
        }
        
        setTimeout(() => {
            setFormStatus({isError: false, message: ''})
        }, 5000);
    }

    return ( 
        <DeviceSetupFormContainer 
            isLoading={isLoadingBrandList}
            handleSubmit={handleDeviceInfo}
            formStatus={formStatus}
            currentStep={2}
            // title="2. Device Information " 
            title={`2. ${t('device_management.device_setup.device_info')} `}
            step={step} setStep={setStep} 
            isValid={true} 
            // stepperPrev="< Select Server Type" 
            // stepperNext={'Device Field Details'} 
            stepperPrev={`< ${t('device_management.server_setup.select_server')} `}
            stepperNext={t('device_management.device_setup.field_details')}
            isNextSubmit={true}>
            
            <InputWithInnerLabel 
            className="col-span-2" 
            // label="Device Name"
            label={t('device_management.device_setup.device_name')}
            name="device_name" placeholder={type =='vehicle'? "AA-1234": "Solar22-41XXX"} required={true}
            defaultValue={deviceSetup?.name}
            />

            <div className="relative grid w-full grid-cols-2 col-span-2 gap-4 mt-5">
                <InputWithInnerLabel 
                    // label="Device Brand"
                    label={`${t('device_management.device_setup.device_brand')}`}
                    name="device_brand" placeholder="Select Brand" 
                    required={true} 
                    type="select" 
                    className="col-span-1" 
                    optionLabel="select brand"
                    defaultValue={deviceSetup?.brand}
                    options={brandList} 
                    onChange={(e)=>handleBrandChange(e.target.value)}
                    />


               <span className="absolute inline-flex items-center gap-1 text-xs font-light -top-6 text-vekin"> <i className=" ri-information-line text-vekin"></i>  {t('device_management.device_setup.suggested_brand')}</span>
                <InputWithInnerLabel 
                    // label="Device Model" 
                    label={`${t('device_management.device_setup.device_model')}`}
                    name="device_model" placeholder="Select Model" 
                    required={true} 
                    disabled={!modelSelectionList}
                    type="select" 
                    className="col-span-1" 
                    optionLabel="select model"
                    defaultValue={deviceSetup?.model}
                    options={modelSelectionList} 
                    />
            </div>

            <InputWithInnerLabel 
            className="col-span-2" 
            type="textarea"
            // label="Device Description" 
            label={t('device_management.device_setup.device_description')}
            name="device_description" placeholder="description of the device" required={false}
            defaultValue={deviceSetup?.description}
            />

        </DeviceSetupFormContainer>
            
     );
}
 

export const SetupDeviceFields = ({step,setStep, deviceDetails, type}) => {
    const { t } = useTranslation("settings");
    const { getDeviceType } = useGetDeviceType()
    const [updateDeviceSetup, deviceSetup, fieldProperties] = useDeviceManagement((state) => [state.updateDeviceSetup, state.deviceSetup, state.fieldProperties],shallow)
    const requiredFields = type === 'vehicle' ? false: true;
    const deviceTypeSelectionList = useMemo(() => {
        if (type === 'vehicle') {
            return getDeviceType?.map((type) => ({ value: type.id, label: type.name })).filter((type) => type.label === "Vehicle");
        } else {
            return getDeviceType?.map((type) => ({ value: type.id, label: type.name })).filter((type) => type.label !== "Vehicle");
        }
    }, [getDeviceType, type]);
    
    // getDeviceType?.map((type)=>({value: type.id, label: type.name})).filter((type)=>type.label != "Vehicle")
    const [fieldInputs, setFieldInputs] = useState(fieldProperties)
    const [formStatus, setFormStatus] = useState({isError: false, message: ''})
  
    const handleDeviceInfo = async (e) => {
        e.preventDefault();
        // get data from form
        const formData = new FormData(e.target);
        const physical_type = formData.get('physical_type');
        const measurement = formData.get('device_measurement');
        const {properties, isEmptyField} = formatFields(formData)

        if (deviceDetails?.hasOwnProperty("brand")) {
            delete deviceDetails["devTypeId"];
        }
        
        if (!physical_type) {
            setFormStatus({ isError: true, message: `${t('device_management.device_setup.required_physical_type')}` });
        } else if (!measurement && type!='vehicle') {
            setFormStatus({ isError: true, message: `${t('device_management.device_setup.required_measurement')}` });
        } else if (isEmptyField && type!='vehicle') {
            setFormStatus({ isError: true, message: `${t('device_management.device_setup.required_field')}` });
        } else {
            let device_type = deviceTypeSelectionList?.filter((type)=>type.value == physical_type)?.[0]?.label
            updateDeviceSetup(({
                ...deviceSetup, // Spread the previous state
                measurement: measurement || deviceSetup?.name.replace(/ /g, '_'),
                property: JSON.stringify(properties),
                physical_type: Number(physical_type),
                type: device_type,
                device_type: device_type,
              })); 
            setStep(n => n+1)
        }

        setTimeout(() => {
            setFormStatus({isError: false, message: ''})
        }, 5000);

         
    }

    const formatFields = (formData) => {
        const formDataArray = [];
        let isEmpty= false
        fieldInputs.forEach(({ address }) => {
            let name = formData.get(`field_name_${address}`)
            let unit = formData.get(`field_unit_${address}`)
            let field = formData.get(`field_value_${address}`)

            if(!name || !unit || !field){
                isEmpty = true
            }
            formDataArray.push({
                name: name,
                unit: unit,
                field: field,
                type: "Float32",
                address: address
            });
        });
        return {properties: formDataArray, isEmptyField: isEmpty};
    }

    const handleFields=(action, address=0)=>{
        switch (action) {
            case "add":
                setFieldInputs(prevState => [...prevState, {address: prevState.length+1}])
                break;
            case "remove":
                setFieldInputs(prevState => prevState.filter(i => i.address !== address))
                break;
            default:
        }
    }

    
    return ( 
        <DeviceSetupFormContainer
            currentStep={3}
            handleSubmit={handleDeviceInfo}
            formStatus={formStatus}
            title={`3. ${t('device_management.device_setup.field_details')} `}
            step={step} setStep={setStep} 
            isValid={true} 
            stepperPrev={`< ${t('device_management.device_setup.device_info')} `}
            stepperNext={t('device_management.device_setup.device_location')}
            isNextSubmit={true}>
            
            <InputWithInnerLabel 
                label={t('device_management.device_setup.physical_type')} name="physical_type" placeholder="Select Type" 
                required={requiredFields} 
                type="select" 
                className="col-span-1" 
                optionLabel="select type"
                options={deviceTypeSelectionList} 
                defaultValue={deviceSetup?.physical_type}
            />
            
            <InputWithInnerLabel 
                className="col-span-1" 
                label={t('device_management.device_setup.measurement')} name="device_measurement" placeholder="device measurement" 
                required={requiredFields}
                defaultValue={deviceSetup?.measurement}
            />

                
            <div className="col-span-2">
               
                <div className="flex flex-col w-full gap-2 max-h-[22rem] overflow-hidden overflow-y-scroll deviceSetup">
                    {fieldInputs.map(({address, unit, field, name},index)=>(
                        <div className="relative grid w-[95%] grid-cols-5 gap-2 "key={index} >
                            
                            <InputWithInnerLabel 
                                className="col-span-2" 
                                label={`${index + 1}. ${t('device_management.device_setup.field_name')}`}
                                name={`field_name_${address}`} placeholder="device field name" 
                                required={requiredFields}
                                defaultValue={name}
                            />
                            <InputWithInnerLabel 
                            className="col-span-1" 
                            label={t('device_management.device_setup.field_unit')} 
                            name={`field_unit_${address}`} placeholder="kWh" 
                            required={requiredFields}
                            defaultValue={unit}
                            />
                            <InputWithInnerLabel 
                            className="col-span-2" 
                            label={t('device_management.device_setup.field_value')}
                            name={`field_value_${address}`} placeholder="_ac_energy" 
                            required={requiredFields}
                            defaultValue={field}
                            />

                            {fieldInputs.length >1 &&
                            <button type="button" className="absolute -right-5 top-3" onClick={()=>handleFields('remove', address)}><i className="text-red-400 ri-close-circle-line"></i></button>
                            }
                        </div>
                    ))}
                </div>
                    <div className="flex flex-row gap-2 pt-2 mt-1 border-t">
                        <button type="button" onClick={()=>handleFields('add')} className="hover:border-vekin transition inline-flex items-center gap-1 text-[10px] border rounded-md px-1"><i className="text-sm ri-add-line"></i> {t('device_management.device_setup.add_field')}</button>
                        <span className="inline-flex items-center gap-1 text-xs font-light text-vekin"> <i className=" ri-information-line text-vekin"></i>  {t('device_management.device_setup.suggested_field')}</span> 

                        
                    </div>
            </div>
        </DeviceSetupFormContainer>
            
              
     );
}

export const SetupDeviceLocation = ({step,setStep,plantId, plantLocation,setupType,handleOnClose, deviceId}) => {
    const { t } = useTranslation("settings");
    const { mutate } = useSWRConfig()
    const [updateDeviceSetup, deviceSetup, selectionList, isEditDevice] = useDeviceManagement((state) => [state.updateDeviceSetup, state.deviceSetup, state.selectionList, state.isEditDevice],shallow)
    const [formStatus, setFormStatus] = useState({isError: false, message: ''})
    const [locationDetails, setLocationDetails] = useState({building:'', floor:''})
    // auto select the first building (If only one building)
    const building_ = selectionList?.buildingSelectionList?.[0]?.floor ?? []
    const floors_ = selectionList?.buildingSelectionList?.length>1?[]:building_?.map((f)=>({value: f?.floor_id, label: f?.floor_name, place:f?.place}))
    const places_ = floors_.length ==1 ?floors_?.[0]?.place?.map((p)=>({value: p?.place_id, label: p?.place_name})) : []
    // const places_
    const [floorSelectionList, setFloorSelectionList] = useState(floors_)
    const [placesSelectionList, setPlacesSelectionList] = useState(places_)
    const [selectedBuilding, setSelectedBuilding] = useState(building_)

    const handleBuildingSelection = (id) => {
        setLocationDetails({building:id, floor:'', place:''})
        const building = selectionList?.buildingSelectionList?.filter((b)=>b?.building_id == id)?.[0]?.floor
        setSelectedBuilding(building)
        const floors = building?.map((f)=>({value: f?.floor_id, label: f?.floor_name}))
        if(floors?.length==1){
            handlePlacesList(building,floors?.[0]?.value)
        }
        setFloorSelectionList(floors)
    }

    useEffect(() => {
      if(floorSelectionList?.length>1){
        setPlacesSelectionList([])
      }
    }, [floorSelectionList])
    
    useEffect(() => {
        if(deviceSetup?.building){
            handleBuildingSelection(deviceSetup?.building)
            setLocationDetails({building:deviceSetup?.building, floor:deviceSetup?.floor, place:deviceSetup?.place})
        }
        
    }, [step]);

    useEffect(() => {
        if (!selectionList?.buildingSelectionList || selectionList.buildingSelectionList.length === 0) {
            setFormStatus({
                isError: true,
                message: (
                    <span>
                        {t('device_management.device_setup.no_location')} 
                        <Link to={`/site/add`} className="text-blue-500 underline">
                            {t('device_management.device_setup.add_location')}
                        </Link>
                        .
                    </span>
                ),
            });
        }
    }, [selectionList?.buildingSelectionList]);


    const handlePlacesList=(_buildings, floorId)=>{
        setLocationDetails({...locationDetails, floor:floorId})
        const buildingPlaces = _buildings?.filter((f)=>f?.floor_id == floorId)?.[0]?.place
        const places = buildingPlaces?.map((p)=>({value: p?.place_id, label: p?.place_name}))

        if(places?.length>1){
            setLocationDetails({...locationDetails, floor:floorId}) 
        }else if (places?.length ==1){
            setLocationDetails({...locationDetails, floor:floorId, place:places?.[0]?.value}) 
        }
        setPlacesSelectionList(places) 
    }

    const handleFloorSelection = (id) => {
        handlePlacesList(selectedBuilding, id)
    }

    const handlePlaceSelection = (id) => {
        setLocationDetails({...locationDetails, place:id})
    }

    const handleDeviceInfo = async (e) => {
        e.preventDefault();

        const formData = new FormData(e.target);
        const building = formData.get('building_name');
        const floor = formData.get('building_floor');
        const place = formData.get('building_place');

        if(!building || !floor || !place){
            if(!building){
                setFormStatus({ isError: true, message: `${t('device_management.device_setup.required_building')}` });
            } else if(!floor){
                setFormStatus({ isError: true, message: `${t('device_management.device_setup.required_floor')}` });
            } else if(!place){
                setFormStatus({ isError: true, message: `${t('device_management.device_setup.required_place')}` });
            }

            setTimeout(() => {
                setFormStatus({isError: false, message: ''})
            }, 5000);
        } else {
              try {
                let resp={}
                if(isEditDevice){
                    resp = await editDevice({details:{...deviceSetup,place: Number(place) }, deviceId:deviceId, plantId:setupType})
                }else{
                    resp = await addDevice({details:{...deviceSetup,place: Number(place) }, type:setupType})
                }
                if(resp?.success){
                    mutate(`/api/plant/${plantId}/device/`)
                    updateDeviceSetup({})
                    setFormStatus({ isError: false, message: isEditDevice ? `${t('device_management.device_setup.updated_device')}` : `${t('device_management.device_setup.created_device')}` });
                    setTimeout(() => {
                        handleOnClose()
                    }, 1000);
                    
                }else{
                    setFormStatus({ isError: true, message: resp?.error });
                }
              } catch (error) {
                setFormStatus({ isError: true, message: `the device could not be ${isEditDevice ? 'updates': 'created'}, please try again!` });
              }
        }
       

        
    }


    return ( 
        <DeviceSetupFormContainer 
            handleSubmit={handleDeviceInfo}
            formStatus={formStatus}
            currentStep={4}
            // title={`4. Device Location Configuration`} 
            title={`4. ${t('device_management.device_setup.location_config')} `}
            step={step} setStep={setStep} 
            isValid={true} 
            // stepperPrev="< Device Field Details" 
            // stepperNext={'Save and Close'}
            stepperPrev={`< ${t('device_management.device_setup.field_details')} `}
            stepperNext={t('device_management.device_setup.save')}
            isNextSubmit={true}>


            <div className="relative grid w-full grid-cols-2 col-span-2 gap-2 ">

                <InputWithInnerLabel 
                    className="col-span-2 capitalize" 
                    readOnly={true}
                    // label="Site"
                    label={t('device_management.device_setup.site')}
                    name="site_name" placeholder="Site Name"
                    defaultValue={plantLocation?.name}
                />

                <InputWithInnerLabel 
                    className="col-span-1" 
                    readOnly={true}
                    // label="Longitude"
                    label={t('device_management.device_setup.longitude')} 
                    name="site_longitude" placeholder="longitude"
                    defaultValue={plantLocation?.location?.lon}
                />

                <InputWithInnerLabel 
                    className="col-span-1" 
                    readOnly={true}
                    // label="Latitude" 
                    label={t('device_management.device_setup.latitude')}
                    name="site_latitude" placeholder="latitude"
                    defaultValue={plantLocation?.location?.lat}
                />
                
                <div className="relative grid w-full grid-cols-2 col-span-2 gap-4 mt-4">
                    {selectionList?.buildingSelectionList && selectionList.buildingSelectionList.length > 0 &&
                    <>
                    <span className="absolute inline-flex items-center gap-1 text-xs font-light -top-6 text-vekin"> <i className=" ri-information-line text-vekin"></i> {t('device_management.device_setup.selected_location')}</span>

                    <InputWithInnerLabel 
                        // label="Building" 
                        label={t('device_management.device_setup.building')}
                        name="building_name" placeholder="Select Brand" 
                        required={true} 
                        type="select" 
                        className="col-span-2" 
                        optionLabel="select building"
                        autoSelectFirst={true}
                        options={selectionList?.buildingSelectionList} 
                        onChange={(e)=>handleBuildingSelection(e.target.value)}
                        defaultValue={locationDetails?.building}
                    />
                    </>
                    }
                
                  {floorSelectionList?.length>0 && <InputWithInnerLabel 
                    // label="Floor"
                    label={t('device_management.device_setup.floor')} 
                    name="building_floor" placeholder="Select Brand" 
                    required={true} 
                    type="select" 
                    className="col-span-1" 
                    optionLabel="select floor"
                    options={floorSelectionList} 
                    autoSelectFirst={true}
                    onChange={(e)=>handleFloorSelection(e.target.value)}
                    defaultValue={locationDetails?.floor}
                    /> }

                    {floorSelectionList?.length>0 &&  placesSelectionList?.length ==0 && <div className="text-xs text-red-500"> This Floor does not have any places configured, select another floor/building</div>}

                  {placesSelectionList?.length>0 && <InputWithInnerLabel 
                    // label="Place" 
                    label={t('device_management.device_setup.place')}
                    name="building_place" placeholder="Select Brand" 
                    required={true} 
                    type="select" 
                    className="col-span-1" 
                    optionLabel="select place"
                    autoSelectFirst={true}
                    options={placesSelectionList} 
                    onChange={(e)=>handlePlaceSelection(e.target.value)}
                    defaultValue={locationDetails?.place}
                    />}
                </div>

                </div>

                {selectionList?.buildingSelectionList && selectionList.buildingSelectionList.length > 0 &&
                <div className="h-56 col-span-2 border">
                    <GoogleMapReact
                        bootstrapURLKeys={{ key: GOOGlE_API_KEY }}
                        center={{ lat:plantLocation?.location?.lat, lng: plantLocation?.location?.lon}}
                        defaultZoom={15}
                    >
                        <Marker
                        lat={plantLocation?.location?.lat}
                        lng={plantLocation?.location?.lon}
                        text={plantLocation?.name}
                        color="red"
                        />
                    </GoogleMapReact>
                </div>
                }
        </DeviceSetupFormContainer>
            
              
     );
}

const Marker = ({ text }) => {
    return (
      <div className="flex flex-row items-center w-56">
        <i className="text-3xl text-red-500 ri-map-pin-fill"></i>
        <span className="w-full text-sm font-bold"> {text}</span>
      </div>
    )
  }



  
 


